export function meterTreeHasData(rootValue: number): boolean {
    return Number.isFinite(rootValue) && rootValue > 0;
}
